import React, { useState } from 'react';
import { Modal, FormGroup, Label } from 'reactstrap';
import PropTypes from 'prop-types';

import close from 'assets/images/general/close.svg';
import CheckboxUnselected from 'assets/images/checkbox-unselected.png';
import CheckboxSelected from 'assets/images/checkbox-selected.png';
import ResaleNotAllowed from 'assets/images/resale-not-allowed.png';
import Funds from 'assets/images/funds.png';
import MDM from 'assets/images/mdm.png';

import './CheckoutPaymentInfo.scss';

export default function CheckoutPaymentInfo({
    isOpen,
    onToggle,
    placeOrder,
    backToOrderSummary
}) {
    const [termsNConditions, setTermsNConditions] = useState(false);
    const [propertyOfCinch, setPropertyOfCinch] = useState(false);
    const [deviceManagementSolution, setDeviceManagementSolution] = useState(false);

    const onChangeTermsNConditions = () => setTermsNConditions(!termsNConditions);

    const onChangeSetPropertyOfCinch = () => setPropertyOfCinch(!propertyOfCinch);

    const onChangeSetDeviceManagementSolution = () => setDeviceManagementSolution(!deviceManagementSolution);

    return (
        <Modal isOpen={isOpen} centered={true} toggle={onToggle}
            backdrop={true} className='knoxGuardModal'>
            <div className='knoxGuardModal__container d-flex align-items-center flex-col'>
                <div className='w-100 knoxGuardModal__container__header'>
                    <div className='d-flex justify-content-center align-items-center user-consent-modal-header'>
                        <h3>User Acknowledgement</h3>
                        <img className='ic-close' src={close} onClick={onToggle}
                            alt='Close' />
                    </div>
                    <div className='d-flex justify-content-center align-items-center images-container'>
                        <div className='images-container__block d-flex flex-col justify-content-center align-items-center'>
                            <img src={ResaleNotAllowed} alt='Resale not allowed'/>
                            <span className='text-center'>Resale not allowed</span>
                        </div>
                        <div className='images-container__block d-flex flex-col justify-content-center align-items-center'>
                            <img src={MDM} alt='Device management soluition detection'/>
                            <span className='text-center'>Mobile Device Management</span>
                        </div>
                        <div className='images-container__block d-flex flex-col justify-content-center align-items-center'>
                            <img src={Funds} alt='Sufficient funds'/>
                            <span className='text-center'>Ensure sufficient funds</span>
                        </div>
                    </div>
                    <div className='mt-3 body-container'>
                        <div>
                            <FormGroup className='agreements-list d-flex' check={true} inline={true}>
                                <img id='propertyOfCinch' name='propertyOfCinch' src={propertyOfCinch ? CheckboxSelected : CheckboxUnselected}
                                    alt='knox Disclaimer indicator' onClick={onChangeSetPropertyOfCinch} />
                                <div>
                                    <Label check={true}
                                        onClick={onChangeSetPropertyOfCinch}
                                        className='cursor-pointer'
                                        htmlFor='propertyOfCinch'>
                                        I understand that this device is property of Cinch and cannot be resold</Label>
                                </div>
                            </FormGroup>
                        </div>
                        <div>
                            <FormGroup className='agreements-list d-flex' check={true} inline={true}>
                                <img id='deviceManagementSolution' name='deviceManagementSolution' src={deviceManagementSolution ? CheckboxSelected : CheckboxUnselected}
                                    alt='knox Disclaimer indicator' onClick={onChangeSetDeviceManagementSolution} />
                                <div>
                                    <Label check={true}
                                        onClick={onChangeSetDeviceManagementSolution}
                                        className='cursor-pointer'
                                        htmlFor='deviceManagementSolution'>
                                        I acknowledge that Cinch may use a Mobile Device Management solution to restrict device usage in the event of non-payment</Label>
                                </div>
                            </FormGroup>
                        </div>
                        <div>
                            <FormGroup className='agreements-list d-flex' check={true} inline={true}>
                                <img id='termsNConditions' name='termsNConditions' src={termsNConditions ? CheckboxSelected : CheckboxUnselected}
                                    alt='knox Disclaimer indicator' onClick={onChangeTermsNConditions} />
                                <div>
                                    <Label check={true}
                                        onClick={onChangeTermsNConditions}
                                        className='cursor-pointer'
                                        htmlFor='termsNConditions'>
                                        I accept the Terms and conditions</Label>
                                </div>
                            </FormGroup>
                        </div>
                    </div>
                    <div className='bottom-container'>
                        <span className='heading'>Please make sure there are sufficient funds in your account before proceeding.</span>
                    </div>
                </div>
                <div className='knoxGuardModal__container__content'>
                    {(!propertyOfCinch || !deviceManagementSolution || !termsNConditions) &&
                    <p className='knoxGuardModal__container__content__noteextra'>You cannot proceed without checking all the boxes.</p>}
                </div>
                <button onClick={placeOrder} disabled={!propertyOfCinch || !deviceManagementSolution || !termsNConditions} className='orderSummary__button'>Place order</button>
                <button onClick={backToOrderSummary} className='orderSummary__back__button'>Back</button>
            </div>
        </Modal>
    );
}

CheckoutPaymentInfo.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func,
    placeOrder: PropTypes.func,
    backToOrderSummary: PropTypes.func,
    onChangeTermsNConditions: PropTypes.func,
    termsNConditions: PropTypes.bool
};
